
// SVG Icon: compare-both-panels
export default { id: "terriajs-compare-both-panels" };
export const id = "terriajs-compare-both-panels";
export const name = "compare-both-panels";
